import {LOADING_APPLICATION, NOTIFICATIONS_APPLICATION, OPEN_WRONG_PAGE} from '../store/actionTypes';

export const loadingApplication = (state = false, action) => {
    switch (action.type) {
        case LOADING_APPLICATION:
            return action.status;
        default:
            return state;
    }
};
export const notificationsApplication = (state = {nextNotification: -1, notifications: []}, action) => {
    switch (action.type) {
        case NOTIFICATIONS_APPLICATION:
            return action.object;
        default:
            return state;
    }
};

export const wrongPage = (state = false, action) => {
    switch (action.type) {
        case OPEN_WRONG_PAGE:
            return true;
        default:
            return state;
    }
};
